import type { ISerialize } from '@/objects/ISerialize';
import { RaceContestantTime } from './RaceContestantTime';

export class SwapTimesBetweenContestantsRequest implements ISerialize {
    public Time1: RaceContestantTime | null;

    public Time2: RaceContestantTime | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { Time1?: RaceContestantTime | null; Time2?: RaceContestantTime | null }) {
        this.Time1 = values.Time1 ?? null;

        this.Time2 = values.Time2 ?? null;
    }

    public serialize(): string {
        return (
            '{' +
            `"Time1": ${!this.Time1 ? null : this.Time1?.serialize()}` +
            ',' +
            `"Time2": ${!this.Time2 ? null : this.Time2?.serialize()}` +
            '}'
        );
    }

    /**
     * Creates an instance of SwapTimesBetweenContestantsRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        Time1?: RaceContestantTime | null;
        Time2?: RaceContestantTime | null;
    }): SwapTimesBetweenContestantsRequest {
        return new SwapTimesBetweenContestantsRequest(values);
    }

    public static _FromServerJson(json: any): SwapTimesBetweenContestantsRequest {
        return new SwapTimesBetweenContestantsRequest({
            Time1: json.Time1 ? RaceContestantTime._FromServerJson(json.Time1) : null,
            Time2: json.Time2 ? RaceContestantTime._FromServerJson(json.Time2) : null,
        });
    }

    /**
     * Creates an instance of SwapTimesBetweenContestantsRequest from another instance of SwapTimesBetweenContestantsRequest.
     * @param other The SwapTimesBetweenContestantsRequest you want to clone
     * @returns A cloned SwapTimesBetweenContestantsRequest
     */
    public static FromOther(other: SwapTimesBetweenContestantsRequest): SwapTimesBetweenContestantsRequest {
        return SwapTimesBetweenContestantsRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SwapTimesBetweenContestantsRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'SwapTimesBetweenContestantsRequest';
}
